import { Box } from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/graphql'

import { type MappedQuestionnaires } from 'modules/performance_process/hooks/useMappedQuestionnaires'

import { StrategyConfigurationsList } from './StrategyConfigurationsList'
import { StrategyConfigurationsProgress } from './StrategyConfigurationsProgress'

type Props = {
  questionnaires: MappedQuestionnaires
  focusStrategy?: PerformanceReviewerStrategiesStrategyEnum | null
}

export const StrategyConfigurationsPanel: React.FC<Props> = ({ questionnaires, focusStrategy }) => {
  return (
    <Box gap="s24">
      <StrategyConfigurationsProgress questionnaires={questionnaires} />
      <StrategyConfigurationsList questionnaires={questionnaires} focusStrategy={focusStrategy} />
    </Box>
  )
}
